<template>
  <i-modal :title="LANG.documentInfo">
    <ModalInformationContent :nodeId="document.nodeId"/>

    <template #footer>
      <div>
        <i-button variant="secondary" @click.prevent="$emit('update:show', false)">{{ LANG.cancel }}</i-button>
      </div>
    </template>
  </i-modal>
</template>

<script>
import { mapState } from 'vuex';
import ModalInformationContent from './ModalInformationContent.vue';

export default {
  components: {
    ModalInformationContent,
  },
  props: {
    document: {
      default: () => ({}),
      type: Object,
    },
  },
  data() {
    return { };
  },
  computed: {
    ...mapState(['LANG']),
  },
};
</script>
